import React from "react";
import {FormattedMessage} from 'react-intl';
import { Link } from "react-router-dom";

export default function SummariesHeader({ headerData, dictionary }) {
   
    function typeOfElement(headerData) {
        switch(headerData.elementType){
            case '1':
                return(
                    <>
                    <span>
                    </span>
                    <span>
                    </span>
                    <span>
                    </span>
                    <span>
                    <Link to={headerData.detailRef ? headerData.detailRef : "/"} className={`${headerData.styleDetail}`}>
                        <FormattedMessage id={`${dictionary}.${headerData.detail}`} defaultMessage={headerData.detail} />
                    </Link>
                    </span> 
                    </>
                )
            case '2':
                return(
                    <>
                    <span>
                    </span>
                    <span>
                    </span>
                    <span>
                    </span>
                    <span>
                    <button className={`btn ${headerData.styleDetail}`}>
                        <FormattedMessage id={`${dictionary}.${headerData.detail}`} defaultMessage={headerData.detail} />
                    </button>
                    </span> 
                    </>
                )
            case "none":
                break;
            default:
        }
    }
    
    return (
        <React.Fragment>
            {
                headerData.title &&
                <React.Fragment>
                    <div className="title_bar" >
                        <div className="title">
                            <i className={`bi ${headerData.icon}`} />
                            <span className="links_name">
                            {
                                headerData.titleCmp ? 
                                headerData.titleCmp :
                                <FormattedMessage id={`${dictionary}.${headerData.title}`} defaultMessage={headerData.title} />
                            }
                            </span>
                        </div>
                        <div className="menu">
                            {typeOfElement(headerData)}
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>  
        
    )
}
